import { useState } from "react";
import MDTypography from "components/MDTypography";
import { IconButton, Tooltip } from "@mui/material";
import DownloadingIcon from "@mui/icons-material/Downloading";
import CTLNotification from "application/components/CTLNotification";
import { application } from "globals/endpoints";

function FsVoicePickerFileDownload({ row }) {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const encodedPath = row.original.id;
  const displayFileName = row.original.fileName;

  function onDownloadFile() {
    application
      .get(`/fsVoicePicker/download?path=${encodeURIComponent(encodedPath)}`, {
        responseType: "blob",
      })
      .then((response) => {
        let filename = displayFileName || "download.mp3";
        const disposition = response.headers["content-disposition"];
        if (disposition && disposition.includes("filename")) {
          const matches = disposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (matches != null && matches[1]) {
            filename = decodeURIComponent(matches[1].replace(/['"]/g, ""));
          }
        }

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

        setNotify({
          isOpen: true,
          message: `MP3 File Download Successful: ${filename}`,
          type: "success",
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        setNotify({
          isOpen: true,
          message: "Unable To Download MP3 File",
          type: "error",
          pagename: "fs voice picker",
          status: error.response ? error.response.status : null,
        });
      });
  }

  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      <Tooltip title="Download File">
        <IconButton color="error" onClick={() => onDownloadFile()}>
          <DownloadingIcon />
        </IconButton>
      </Tooltip>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDTypography>
  );
}

export default FsVoicePickerFileDownload;
